import React from "react";
import PropTypes from "prop-types";

import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";

const Fieldset = (props) => {
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} windowWidth={props.tooltipWindowWidth} windowAlignRight={props.tooltipWindowAlignRight} /> : null;
	const linkText = props.linkText ? props.linkText : "";
	const linkUrl = props.linkUrl ? props.linkUrl : "";
	const link = linkText ? <a href={linkUrl} target="_blank" style={{ color: 'blue', 'fontSize': '12px' }}>{linkText}</ a> : null;
	const titleText = props.title ? props.title : "";
	const title = titleText ? <span>{props.title} {info} {link}</span> : null;
	const fieldsetClassName = "c-fieldset" + (props.widthInCols > 0 ? " o-col-" + props.widthInCols : "");
	const legendClassName = (props.removeHeaderSpacing ? "" : "c-fieldset__header") + " o-col-12 u-clear";

	return (
		<fieldset className={fieldsetClassName}>
			{props.title ?
				<legend className={legendClassName}>
					{title}
				</legend> : null}
			{props.children}
		</fieldset>
	);
};

Fieldset.propTypes = {
	title: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	children: PropTypes.node,
	widthInCols: PropTypes.number,
	removeHeaderSpacing: PropTypes.bool,
	linkText: PropTypes.string,
	linkUrl: PropTypes.string
};

export default Fieldset;